import { makeStyles } from '@material-ui/styles';
import { MainButton } from '@bizzabo/design-system';

const ChatMessageDialogConfirmCancelFooter = ({
    cancelText = 'Cancel',
    confirmText = 'Confirm',
    onClose,
    onConfirm,
}) => {
    const classes = useStyles();
    return (
        <div className={classes.actions}>
            <MainButton onClick={onClose} className={classes.cancelAction}>
                {cancelText}
            </MainButton>
            <MainButton onClick={onConfirm} variant={'fill'}>
                {confirmText}
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    () => ({
        actions: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        },
        cancelAction: {
            marginRight: 12,
        },
    }),
    { classNamePrefix: 'ChatMessageDialogConfirmCancelFooter' }
);

export default ChatMessageDialogConfirmCancelFooter;
